import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useAppStore } from '@/store/modules/app';

export default /*#__PURE__*/_defineComponent({
  __name: 'AlertModal',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createBlock(_component_base_modal, {
    "show-modal": _unref(useAppStore)().showAlertModal.show,
    title: _unref(useAppStore)().showAlertModal.title,
    class: "alert-modal",
    onClose: _cache[0] || (_cache[0] = ($event: any) => (_unref(useAppStore)().closeAlert()))
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass([{
          'error-color': _unref(useAppStore)().showAlertModal.type === 'error',
          'main-color': _unref(useAppStore)().showAlertModal.type === 'success',
        }, "l-font-size"])
      }, _toDisplayString(_unref(useAppStore)().showAlertModal.text), 3)
    ]),
    _: 1
  }, 8, ["show-modal", "title"]))
}
}

})